import Layout from './Layout/Loading';
import React from 'react';

export const Loading = () => {
    return <Layout />;
};
Loading.displayName = 'Loading';

export default Loading;
